<template>
    <Dimmer
        class="collections-filter-tags"
        :hide-spinner="true"
        :model-value="progress"
    >
        <template #content>
            <div
                class="d-flex align-center w-100"
            >
                <a
                    href="#"
                    class="
                        me-4
                        text-no-wrap
                        d-inline-block
                        text-decoration-none
                        text-uppercase
                        font-size-8
                        letter-spacing-6
                        font-weight-medium
                    "
                    @click.prevent="emit('on-reset-filters')"
                >
                    Clear All
                </a>
                <v-chip-group>
                    <template
                        v-for="tag in tags"
                        :key="`col-filter-tag-${tag[0]}`"
                    >
                        <v-chip
                            variant="outlined"
                            size="small"
                            @click:close="clearTag(tag[0])"
                            closable
                        >
                            {{ tag[1] }}
                        </v-chip>
                    </template>
                </v-chip-group>
            </div>
        </template>
    </Dimmer>
</template>

<script lang="ts" setup>
    import Dimmer from 'x1-base/components/Dimmer/Dimmer.vue';
    import type {
        ProductFilterModel,
        ProductFilterAttribute
    } from '~/types';

    const props = defineProps<{
        modelValue: ProductFilterModel;
        filters: ProductFilterAttribute[];
        productsLoading: boolean;
        productsPaging: boolean;
    }>();

    const emit = defineEmits<{
        'on-reset-filters': [value: void];
        'on-change': [value: [parentUid: string, uid: string, value: boolean]];
    }>();

    const tags = ref<Map<string, string>>(new Map());
    const progress = computed<boolean>(() => props.productsLoading || props.productsPaging);

    const unWatchFilters = watch(
        [
            () => props.modelValue,
            () => props.filters
        ],
        getTags,
        {
            immediate: true,
            deep: true
        }
    );

    function getTags(
        [newModel, newFilters]: [ProductFilterModel, ProductFilterAttribute[]]
    ): void {
        const map = new Map<string, string>();
        newFilters.forEach((filter) => {
            const pUid = filter.uid!;
            filter.values.forEach((fValItem) => {
                const { uid, name } = fValItem;
                const isOn = newModel[pUid]![uid!];

                if (isOn) {
                    map.set(`${pUid}:${uid}`, name);
                }
            });
        });

        tags.value = map;
    }

    function clearTag(uidPath: string): void {
        const [ pUid, uid ] = uidPath.split(':');
        if (pUid && uid) {
            emit('on-change', [ pUid, uid, false ]);
        }
    }

    onBeforeUnmount(() => {
        unWatchFilters();
    });
</script>

<style lang="scss"></style>

